const MtrArrowUpOutline={
    "name": "mtr-arrow-up",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M5.71929 16.121C5.62704 16.2165 5.5167 16.2927 5.39469 16.3451C5.27269 16.3975 5.14147 16.4251 5.00869 16.4263C4.87591 16.4274 4.74423 16.4021 4.62133 16.3518C4.49844 16.3015 4.38679 16.2273 4.29289 16.1334C4.199 16.0395 4.12475 15.9278 4.07447 15.805C4.02419 15.6821 3.99888 15.5504 4.00004 15.4176C4.00119 15.2848 4.02878 15.1536 4.08119 15.0316C4.1336 14.9096 4.20978 14.7992 4.30529 14.707L12.0123 7L19.7193 14.707C19.9014 14.8956 20.0022 15.1482 20 15.4104C19.9977 15.6726 19.8925 15.9234 19.7071 16.1088C19.5217 16.2942 19.2709 16.3994 19.0087 16.4017C18.7465 16.404 18.4939 16.3032 18.3053 16.121L12.0123 9.828L5.71929 16.121Z",
                    "fill": "currentColor"
                }
            }
        ]
    }
};
export default MtrArrowUpOutline;